import React from "react";

import { ReactComponent as SearchIcon } from "../../build/images/icons/search02.svg";

import "./input-search-back-pagination.css";

const defaultHandleClick = () => {};

function InputSearchBackPagination({
  search,
  setSearch,
  handleClick = defaultHandleClick,
  placeholder,
  onSearch,
  icon,
  onKeyDown,
  onChange,
  exibIcon = true,
}) {
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  return (
    <div className="inputSearchOpts__input inputSearchOptsInput">
      <input
        className="inputSearchOptsInput__input"
        type="text"
        placeholder={placeholder ? placeholder : "Pesquisar"}
        value={search}
        onChange={({ target }) => {
          setSearch(target.value);
          const hasOnChange = !!onChange;
          if (hasOnChange) {
            onChange(target.value);
          }
        }}
        onKeyDown={onKeyDown ? handleKeyDown : null}
      />
      {exibIcon && (
        <button className="inputSearchOptsInput__btn" onClick={onSearch}>
          {icon ? icon : <SearchIcon />}
        </button>
      )}
    </div>
  );
}

export default InputSearchBackPagination;
